import { Bucket, getBucketUrl } from "./auth";

export const getImagePathBucketPacoca = (path?: string, imgPlaceholder: string = "/img/img-placeholder.jpg", bucket: Bucket = Bucket.PACOCA) => {
    return path ? (`${getBucketUrl(bucket)}/${path}`) : imgPlaceholder;
};

export const getImageNotFound = (name?: string) =>{
    return name?.length ? `https://ui-avatars.com/api/?name=${name?.replaceAll(" ", "+")}&background=random&size=64` : "/img/img-placeholder.jpg";
}